import { ImgHTMLAttributes } from 'react';

import styles from './FixedIncomeLogo.module.scss';

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  'data-testid'?: string;
}

interface FixedIncomeLogoProps {
  entityTag: string;
  imgProps: ImageProps;
}

const tenorDurationRegExp = /([\d]+[a-z])_?([\d]+[a-z])?/;

const getTenorDuration = (entityTag: string) => {
  const match = entityTag.match(tenorDurationRegExp);

  if (match) {
    return match[2] ? `${match[1]}${match[2]}` : match[1];
  }

  return '';
};

export const FixedIncomeLogo = ({
  entityTag,
  imgProps,
}: FixedIncomeLogoProps) => {
  const tenorDuration = getTenorDuration(entityTag);
  return (
    <>
      {tenorDuration && <span className={styles.badge}>{tenorDuration}</span>}
      <img {...imgProps} />
    </>
  );
};
